export const services = [
  {
    id: 1,
    title: 'Vendor Sourcing',
    description: 'Pre-vetted Indian manufacturers across EMS, PCB assembly, plastics, metal fabrication, packaging, cable harnesses, and ready-made products.',
    icon: 'Search'
  },
  {
    id: 2,
    title: 'Manufacturing Project Management',
    description: 'Prototype development, DFM, BOM optimization, tooling coordination, and production tracking.',
    icon: 'Settings'
  },
  {
    id: 3,
    title: 'Quality & Compliance',
    description: 'Factory audits, quality inspections, and certification coordination including ISO, CE, FDA, IPC, and BIS.',
    icon: 'CheckCircle'
  },
  {
    id: 4,
    title: 'Logistics & Export Support',
    description: 'Freight coordination, export documentation, customs clearance, and consolidation support.',
    icon: 'Truck'
  },
  {
    id: 5,
    title: 'Consulting & Advisory',
    description: 'Cost optimization, sourcing strategy, supplier comparison, and risk assessment.',
    icon: 'Users'
  }
];

export const manufacturingProcess = [
  {
    id: 1,
    step: 'Step 1',
    title: 'Idea & Requirements Understanding',
    description: 'We analyze your product requirements, specifications, and business objectives.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/2snmfhyu_progettazione-elettronica-schematici.jpg'
  },
  {
    id: 2,
    step: 'Step 2',
    title: 'Supplier Identification & Costing',
    description: 'Finding the perfect manufacturing partners with competitive pricing.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/g0u81z1i_Supplier%20Sourcing%20%26%20Costing.jpg'
  },
  {
    id: 3,
    step: 'Step 3',
    title: 'Prototype & DFM Optimization',
    description: 'Refining designs for manufacturing efficiency and quality.',
    image: 'https://images.pexels.com/photos/26510348/pexels-photo-26510348.jpeg'
  },
  {
    id: 4,
    step: 'Step 4',
    title: 'Production & Quality Control',
    description: 'Rigorous oversight of manufacturing with strict quality standards.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/dbh3dfbr_Production%20Quality%20Control.png'
  },
  {
    id: 5,
    step: 'Step 5',
    title: 'Logistics, Export & Delivery',
    description: 'Seamless global shipping and customs handling.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/bohmknsn_Logistics%20Export%20and%20Delivery.jpg'
  }
];

export const industries = [
  {
    id: 1,
    name: 'Electronics & EMS',
    description: 'Full-service electronic manufacturing solutions from PCB assembly to finished products.',
    image: 'https://images.pexels.com/photos/343457/pexels-photo-343457.jpeg',
    icon: 'Cpu'
  },
  {
    id: 2,
    name: 'Industrial Automation',
    description: 'Drive efficiency, enhance product value, and boost competitiveness with IoT integration',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/bmt4yh4y_IoT-IIoT-Industrial-Internet-Connectivity-Automation-Robotics-Digital-Technologies-Stock-Image.jpg',
    icon: 'Cog'
  },
  {
    id: 3,
    name: 'Plastics & Injection Moulding',
    description: 'Custom plastic components and enclosures with precision molding.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/s5d41844_Injection%20Mould.png',
    icon: 'Box'
  },
  {
    id: 4,
    name: 'Product Packaging',
    description: 'Consumer product packaging and ready-to-market solutions.',
    image: 'https://customer-assets.emergentagent.com/job_068c6455-6a9f-475f-b981-6fecca8bb2f5/artifacts/i205xlbx_consumer_electronic_10.jpg.webp',
    icon: 'Package'
  },
  {
    id: 5,
    name: 'Startups & SMEs',
    description: 'Tailored manufacturing support for emerging businesses.',
    image: 'https://images.unsplash.com/photo-1588856122867-363b0aa7f598?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzdGFydHVwJTIwd29ya3NwYWNlfGVufDB8fHx8MTc2OTg0MjkzMHww&ixlib=rb-4.1.0&q=85',
    icon: 'Zap'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Trusted Network',
    description: 'Strong network of trusted Indian manufacturers',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Transparent Pricing',
    description: 'Zero hidden commissions, clear cost breakdowns',
    icon: 'DollarSign'
  },
  {
    id: 3,
    title: 'End-to-End Support',
    description: 'From prototype to shipment, we handle it all',
    icon: 'CheckCircle2'
  },
  {
    id: 4,
    title: 'Fast Turnaround',
    description: 'Faster delivery times with cost efficiency',
    icon: 'Clock'
  },
  {
    id: 5,
    title: 'Low MOQ Friendly',
    description: 'Ideal for startups and low-volume programs',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    title: 'Multi-Domain Expertise',
    description: 'Electronics and mechanical manufacturing experts',
    icon: 'Award'
  }
];

export const stats = [
  { id: 1, value: '500+', numericValue: 500, suffix: '+', label: 'Products Manufactured' },
  { id: 2, value: '50+', numericValue: 50, suffix: '+', label: 'Global Clients' },
  { id: 3, value: '15+', numericValue: 15, suffix: '+', label: 'Years Experience' },
  { id: 4, value: '98%', numericValue: 98, suffix: '%', label: 'Client Satisfaction' }
];

// Hero video for background
export const heroVideo = 'https://videos.pexels.com/video-files/6754820/6754820-uhd_2560_1440_25fps.mp4';

// Video poster/fallback image (still frame from the video)
export const heroVideoPoster = 'https://images.pexels.com/videos/6754820/pexels-photo-6754820.jpeg?auto=compress&cs=tinysrgb&w=1920';

// Fallback hero image
export const heroImage = 'https://ems-showcase-spark.lovable.app/assets/ems-pcb-assembly-D8lKuHVV.jpg';
